import moment, {isDate, isMoment} from "moment";

class JsonMapper {

    private static dateFormat: RegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.\d+)?Z?$/;

    private static reviver(key: string, value: any) {
        if (typeof value === "string" && JsonMapper.dateFormat.test(value)) {
            if (value.endsWith("Z")) {
                value = value.replace('Z', "")
            }
            const date = moment(value);
            if (date.isValid()) {
                return date.toDate();
            }
        }

        return value;
    }

    public parse(obj: string): any {
        return JSON.parse(obj, JsonMapper.reviver)
    }

    private replacer = function (key: any, processedValue: any) {
        // @ts-ignore
        const rawValue = this[key];
        if (isDate(rawValue) || isMoment(rawValue)) {
            return moment(rawValue).format("YYYY-MM-DDTHH:mm:ss");
        }

        return processedValue;
    }

    public stringify(obj: any): string {
        return JSON.stringify(obj, this.replacer)
    }
}

export const jsonMapper = new JsonMapper();